import styled, { css } from 'styled-components';
import { InputField } from '../InputField/InputField.styles';

type SelectFieldAttributes = {
  width: number;
};

export const FieldSelect = styled.select<SelectFieldAttributes>(
  ({ width }) => css`
    ${InputField()}
    width: ${width}%;

    > option {
      background-color: rgb(191 191 191);
      transition: background-color 0.3s;
      color: rgb(0 0 0);

      appearance: none;
      outline: none;

      border: none;
      height: 50px;

      &:hover,
      &:focus,
      &:active,
      &:checked,
      &:selected {
        background-color: rgb(255 255 255);
      }

      &:first-child {
        display: none;
      }
    }

    &:focus,
    &:active {
      border-color: rgb(0 0 0);

      > option:checked {
        background-color: rgb(255 255 255);
      }
    }
  `
);

export const SelectDropdown = styled.div`
  box-shadow: 0 3px 6px 0 rgb(0 0 0 / 0.16);
  border: 1px solid rgb(34 34 34);

  overscroll-behavior: contain;
  overflow: hidden auto;
  position: absolute;

  max-height: 25dvh;
  min-height: 50px;
  border-top: none;

  width: 100%;
  z-index: 1;

  > option {
    background-color: rgb(191 191 191);
    color: rgb(0 0 0);
    padding: 15px;
  }
`;
